import Prices from './Prices.redux';

export default Prices;
